import { useSwiper } from 'swiper/react';
import { Direction } from '../../util/util';
import { className } from '@empori/util';
import { FaIcon } from '../../generic/icon';

export interface NavigationButtonProps {
  direction: Direction;
  absolute?: boolean;
}

export function NavigationButton({ direction, absolute }: NavigationButtonProps) {
  const swiper = useSwiper();
  const leftOrRight = direction === Direction.next ? 'right' : 'left';

  const handleChange = () => {
    if (direction === Direction.next) {
      swiper.slideNext();
      return;
    }

    swiper.slidePrev();
  };

  return (
    <div
      className={className(`empori-slideshow-navigation-item ${leftOrRight}`,
        { 'nav-absolute': absolute })}
      onClick={handleChange}>
      <FaIcon clsName={`fa-regular fa-chevron-${leftOrRight}`} />
    </div>
  );
}